import NavItem from './src/NavItem';

export default NavItem;
